import { render, staticRenderFns } from "./RejectDialog.vue?vue&type=template&id=13ed7244&scoped=true"
import script from "./RejectDialog.vue?vue&type=script&lang=js"
export * from "./RejectDialog.vue?vue&type=script&lang=js"
import style0 from "./RejectDialog.vue?vue&type=style&index=0&id=13ed7244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed7244",
  null
  
)

export default component.exports